// extracted by mini-css-extract-plugin
export var container = "d5_g";
export var fadeDiv = "d5_hb";
export var placeholderWrapper = "d5_sF";
export var video = "d5_pW";
export var videoWrapper = "d5_mc";
export var vimeoPlayer = "d5_sG";
export var wrapper = "d5_C";